module.exports = "<div class=\"panel panel-{{this.message.type}} message-panel\" [@message]=\"state\" (@message.start)=\"this.onBegin($event)\" (@message.done)=\"this.onEnd($event)\"><div class=\"panel-heading\">STATUS: {{ this.message.status }}</div><div class=\"panel-body\">{{ this.message.statusText }}</div><div class=\"panel-footer\" (click)=\"this.cancel()\">Cancel</div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/app-alerts/app-alerts.component.pug
// module id = 1106
// module chunks = 1